export function extractExtraction(str: string) {
    const regexPettern = /\b(jpeg|webp|png)\b/i
    const match = str.match(regexPettern)
    return match?.length ? match[1] : null
  }
